<template>
<div class="chapter">
<div class="inner_page">
<p class="ded"><span><i>For the inimitable Kitty Lorentzen,</i></span></p>
<p class="ded1"><span><i>of Bedford, Bermuda, and the Bowery;</i></span></p>
<p class="ded1-2"><span><i>with special thanks</i></span></p>
<p class="ded1"><span><i>to Christopher Knapp Haynes.</i></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// frontmatter01.vue?32a8f89c